<template>
  <div class="destination-general-main">
    <div class="flex-row">
      <div class="customBox" style="width:90%;">
        <span id="spanRequiredTime">Destination Type</span>
        <div class="flex-row" id="divRequiredTime">
          <Dropdown placeholder="Destination Type" ref="destType" :selectedObject.sync="data.selectedDestType" :items="data.destTypeItems"
                    :search.sync="data.destTypeSearch" isRequired="true" :isDisabled="viewMode" style="padding: 0 5px 0 5px;" />
          <Input placeholder="Customer Code" style="padding: 0 5px 0 5px;" :inputValue.sync="data.custCode" :isDisabled="CSView" />
        </div>
      </div>
      <CheckBox id="checkBox" title="Own Staging Dest?" :isChecked.sync="data.ownStagingDest" :isDisabled="viewMode" style="display: flex; align-items: center; padding-top: 25px;"/>
    </div>
    <InputQuery placeholder="Tariff Area" isRequired="true" ref="tariffArea" :items="data.areaCodeItems" itemKey="Area Code" descKey="Description"
                :search.sync="data.areaCodeSearch" :selectedObject.sync="data.selectedAreaCode" :isDisabled="viewMode" />
    <Input placeholder="Company Name" isRequired="true" ref="compName" style="padding-right:5px" :inputValue.sync="data.company" :isDisabled="viewMode" />
    <AddressForm :data="data" :viewMode="viewMode" />
    <div class="flex-row">
      <div class="insideFlexRow">
        <div class="customBox">
          <span id="spanRequiredTime">Required Time</span>
          <div class="flex-row" id="divRequiredTime">
            <CheckBox id="checkBox" title="Office Hours?" :isChecked.sync="data.isOfficeHrs" :isDisabled="viewMode" style="padding: 0 5px 0 5px; width:50%;" />
            <Input placeholder="Required Time Description" style="padding: 0 5px 0 5px" :inputValue.sync="data.requiredTime" :isDisabled="requiredTimeView" />
          </div>
        </div>
      </div>
      <div class="insideFlexRow" style="display: flex; align-items: flex-end;">
        <InputQuery placeholder="Zone Type" :ref="zoneType" :items="data.zoneTypeItems" itemKey="Zone Type" descKey="Description"
                    :search.sync="data.zoneTypeSearch" :selectedObject.sync="data.selectedZoneType" :isDisabled="viewMode" style="padding:0 0 10px 5px;" />
      </div>
    </div>
    <div class="flex-row">
      <Input placeholder="Phone No." style="padding-right: 5px" :inputValue.sync="data.phone" :isDisabled="viewMode"/>
      <Input placeholder="Fax No." style="padding-left: 5px" :inputValue.sync="data.fax" :isDisabled="viewMode" />
    </div>
    <Input placeholder="Email" style="padding-right: 5px" :inputValue.sync="data.email" :isDisabled="viewMode" />
    <div class="flex-row">
      <Input placeholder="Contact" style="padding-right: 5px" :inputValue.sync="data.contact" :isDisabled="viewMode" />
      <Input placeholder="H/P No." style="padding-left: 5px" :inputValue.sync="data.hp" :isDisabled="viewMode" />
    </div>
    <div class="flex-row">
      <InputQuery placeholder="Opr Tariff Area" ref="oprTariffArea" :items="data.oprAreaCodeItems" itemKey="Area Code" descKey="Description"
                  :search.sync="data.oprAreaCodeSearch" :selectedObject.sync="data.selectedOprAreaCode" :isDisabled="viewMode" />
      <Dropdown placeholder="Premise Is" :selectedObject.sync="data.selectedPremise" :items="data.premiseItems"
                :search.sync="data.premiseSearch" :isDisabled="viewMode" style="padding-left: 5px" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import Dropdown from '@/components/Dropdown.vue';
import CheckBox from '@/components/CheckBox.vue';
import InputQuery from '@/components/InputQuery.vue';
import AddressForm from '@/components/AddressForm.vue';

export default {
  components: {
    Input, Dropdown, CheckBox, InputQuery, AddressForm,
  },
  props: {
    data: { type: Object, default: function() { return {} } },
    viewMode: { type: Boolean, default: false },
    requiredTimeView: { type: Boolean, default: false },
    CSView: { type: Boolean, default: true },
  },
  methods: {
    setFocus: function (data) {
      // this.custTypeRequired = (data['element'] == 'cu_type' ? true : false);
      try { this.$refs[data['element']].setFocus(); } catch (e) { this.$bus.$emit('destinationPageChange', data['page']); };
    },
  },
  watch: {
    data: {
      deep: true,
      handler(val) {
        if (val.isOfficeHrs == 1) {
          this.requiredTimeView = true;
          this.data.requiredTime = '';
        } else if (this.viewMode == true) {
          this.requiredTimeView = true;
        } else {
					this.requiredTimeView = false;
        }
        this.CSView = val.selectedDestType ? val.selectedDestType['#'] == 1 ? false : true : true;
      }
    }
  },
  mounted() {
    this.$bus.$on('destinationSetFocus', this.setFocus);
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.flex-row {
  display: flex;
  justify-content: space-between;
}

.insideFlexRow {
  width: 50%;
}

#divRequiredTime {
  border: solid 1px rgb(169, 169, 169);
  padding: 5px 0 5px 0;
}

#spanRequiredTime {
  font-size: 12px;
}

#checkBox {
  font-size: 12px;
}

.customBox {
  padding-bottom: 5px;
}
</style>